
    import * as React from 'react';

    const ChevronRight60 = ({ color = 'currentcolor', height = '60px', width = '60px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 60 60" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M39 30.3258L21.5389 50.6516L20.7804 50L37.6817 30.3258L20.7804 10.6516L21.5389 10L39 30.3258Z" /></svg>
        </div>
      );
    };

    ChevronRight60.displayName = 'ChevronRight60';

    export default ChevronRight60;
  